export default "__VITE_ASSET__DnARLY3M__"